/* eslint-disable react/no-danger */
import React from 'react';
import PropsType from 'prop-types';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import './index.scss';
import ButtonComponent from '@/components/Button';
import { parseDateYear, formatCurrency } from '@/utils/formatter';
import { ROUTES } from '@/constants';

function CurrentPlan({ plan, endTime, bestPlan }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const renderItemString = ({ label, value }) => (
    <div className="plan-detail__item">
      <p className="mb-0">{label}</p>
      <p className="mb-0 plan-detail__item__value">{value}</p>
    </div>
  );
  const renderItemCheck = ({ label, value }) => (
    <div className="plan-detail__item">
      <p className="mb-0">{label}</p>
      {value ? (
        <span className="subscriptions-card__item__icon --current" />
      ) : (
        <span className="subscriptions-card__item__icon --close" />
      )}
    </div>
  );

  const handleRenew = () => {
    navigate(`${ROUTES.SUBSCRIPTIONS.INDEX}/${plan.id}/subscribe`);
  };
  const handleChangePlane = () => {
    navigate(ROUTES.SUBSCRIPTIONS.LIST);
  };

  const handleUpgrade = () => {
    navigate(`${ROUTES.SUBSCRIPTIONS.INDEX}/${bestPlan.id}/subscribe`);
  };

  const renderBestPlan = () => {
    if (!bestPlan) {
      return null;
    }
    return (
      <Col lg={{ span: 12 }} span={24}>
        <div className="plan-detail__transaction">
          <Row className="plan-detail__transaction__container">
            <Col lg={{ span: 14 }} span={24}>
              <h3 className="plan-detail__transaction__title">
                {t('subscriptions_page.main_content.best_seller_plan.title')}
              </h3>
              <h1 className="plan-detail__transaction__price">
                ฿{parseFloat(bestPlan.price).toLocaleString() || 0}
              </h1>
              <div className="plan-detail__transaction__item">
                <p className="mb-0">
                  {t(
                    'subscriptions_page.main_content.best_seller_plan.num_of_msg',
                  )}
                </p>
                <p className="mb-0 plan-detail__transaction__item__value">
                  {bestPlan.creditNumber?.toLocaleString() || 0}
                </p>
              </div>
              <div className="plan-detail__transaction__item">
                <p className="mb-0">
                  {t(
                    'subscriptions_page.main_content.best_seller_plan.price_per_msg',
                  )}
                </p>
                <p className="mb-0 plan-detail__transaction__item__value">
                  {bestPlan.pricePerMsg}
                </p>
              </div>
              <div className="plan-detail__transaction__item">
                <p className="mb-0">
                  {t(
                    'subscriptions_page.main_content.best_seller_plan.validity_period',
                  )}
                </p>
                <p className="mb-0 plan-detail__transaction__item__value">
                  {parseFloat(bestPlan.period)}
                  {parseFloat(bestPlan.period) >= 2
                    ? ` ${t('common.years')}`
                    : ` ${t('common.year')}`}
                </p>
              </div>
            </Col>
            <Col lg={{ span: 14 }} span={24}>
              <ButtonComponent
                className="plan-detail__transaction__btn"
                onClick={handleUpgrade}
                type="primary"
              >
                {t(
                  'subscriptions_page.main_content.best_seller_plan.btn_upgrade',
                )}
              </ButtonComponent>
            </Col>
          </Row>
        </div>
      </Col>
    );
  };

  const renew =
    parseFloat(plan.period) > 1
      ? `${t('common.every')} ${parseFloat(plan.period)} ${t('common.years')}`
      : `${t('common.every')} ${parseFloat(plan.period)} ${t('common.year')}`;
  return (
    <div className="plan-detail">
      <h3 className="plan-detail__head">
        {t('subscriptions_page.main_content.plan.title')}
      </h3>
      <div className="plan-detail__desc">
        <p
          dangerouslySetInnerHTML={{
            __html: t('subscriptions_page.main_content.plan.description'),
          }}
        />
        <p className="plan-detail__date">
          {t('subscriptions_page.main_content.plan.expired_at', {
            date: parseDateYear(endTime),
          })}
        </p>
      </div>
      <Row gutter={[16, 24]}>
        <Col lg={{ span: 12 }} span={24}>
          <div className="plan-detail__package">
            <div className="plan-detail__package__container">
              <h3 className="plan-detail__title">
                {t(`subscription_page.packages.${plan.nameInEnglish}`)}
              </h3>
              <div className="plan-detail__group-price">
                <p className="plan-detail__price">
                  {formatCurrency(plan.price)}
                </p>
              </div>
              {renderItemString({
                label: t(
                  'subscriptions_page.main_content.plan.package_detail.renew',
                ),
                value: renew,
              })}
              {renderItemString({
                label: t(
                  'subscriptions_page.main_content.plan.package_detail.num_of_msg',
                ),
                value: plan.creditNumber?.toLocaleString() || 0,
              })}
              {renderItemString({
                label: t(
                  'subscriptions_page.main_content.plan.package_detail.price_per_msg',
                ),
                value: plan.pricePerMsg,
              })}
              {renderItemCheck({
                label: t(
                  'subscriptions_page.main_content.plan.package_detail.request_sender_name',
                ),
                value: plan.isSenderIdVerification,
              })}
              {renderItemCheck({
                label: t(
                  'subscriptions_page.main_content.plan.package_detail.send_sms_via_api',
                ),
                value: plan.isApiAccess,
              })}
            </div>
            <Row gutter={[8, 12]} className="w-100">
              <Col lg={{ span: 12 }} span={24}>
                <ButtonComponent
                  className="plan-detail__btn"
                  onClick={handleRenew}
                >
                  <span className="plan-detail__btn__refresh --black" />
                  {t('subscriptions_page.main_content.plan.btn_renew')}
                </ButtonComponent>
              </Col>
              <Col lg={{ span: 12 }} span={24}>
                <ButtonComponent
                  type="primary"
                  className="plan-detail__btn"
                  onClick={handleChangePlane}
                >
                  <span className="plan-detail__btn__refresh" />
                  {t('subscriptions_page.main_content.plan.btn_change_plan')}
                </ButtonComponent>
              </Col>
            </Row>
          </div>
        </Col>
        {renderBestPlan()}
      </Row>
    </div>
  );
}

CurrentPlan.propTypes = {
  plan: PropsType.object,
  endTime: PropsType.string,
  bestPlan: PropsType.object,
};

export default CurrentPlan;
